import { Guide } from "@agp/shared.user-app/entity";
import { twMerge } from "tailwind-merge";
import ServiceLocator from "../../../../../domain/service-locator";
import PlayingAnimation from "../../../../components/playing-animation";
import { Divider } from "../../../../components/divider";

const GuideItem = (props: {
  onClickGuide: (id: string) => void;
  guide: Guide;
  active: boolean;
  isListened: boolean;
}) => {
  const isPlaying = ServiceLocator.GuidePlayerModule.isPlaying.watch();
  return (
    <>
      <div
        className="cursor-pointer"
        onClick={() => props.onClickGuide(props.guide.id)}
      >
        <div className="flex items-center h-24">
          <div className="flex justify-center items-center h-full aspect-[4/3] bg-black text-white font-bold text-[3rem]">
            {props.guide.trackNumber}
          </div>
          {/*<img*/}
          {/*  className="h-full"*/}
          {/*  src={props.guide.thumbnailUrls[0] || "/no-image.png"}*/}
          {/*/>*/}
          <div className="flex-grow">
            <div className="flex items-center justify-between gap-2 pl-4 pr-4">
              <div className="flex items-center gap-2">
                {props.active && <PlayingAnimation active={isPlaying} />}
                <div
                  className={twMerge(
                    "text-xl",
                    props.isListened && "font-bold"
                  )}
                >
                  {props.guide.trackNumber} . {props.guide.name}
                </div>
              </div>
              <div className={"relative"}>
                <div
                  className={
                    "absolute bg-[#a39323] rounded-full w-10 h-10 top-[50%] left-[50%] -translate-x-1/2 -translate-y-1/2"
                  }
                />
                <img
                  alt="expandable-button"
                  src="/minpaku-demo/icons/expand-button.svg"
                  className={`h-12 w-12 -rotate-90`}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Divider />
    </>
  );
};

export default GuideItem;
